import { render, staticRenderFns } from "./VesselCertificates.vue?vue&type=template&id=74a7593e&scoped=true"
import script from "./VesselCertificates.vue?vue&type=script&lang=js"
export * from "./VesselCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a7593e",
  null
  
)

export default component.exports